<template>
  <div class="cp-section">
    <div class="cp-section__list" v-if="order">
      <div class="mr-auto mt-0">
        <div class="cp-header-text" @click.stop="backToOrderList()">
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="13" viewBox="0 0 6 13" fill="none">
            <path d="M5 9L1 5L5 1" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="13" viewBox="0 0 6 13" fill="none" class="mr-1">
            <path d="M5 9L1 5L5 1" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Back to order list
        </div>
      </div>
      <div class="cp__orders__container">
        <OrderTile @selectInput="selectInput" :order="order" :is-order-detail="true"
                   :inputs="validInputs"
        />
        <b-card no-body class="cp__order__info__box" v-if="paymentInfo">
          <b-card-body class="d-flex justify-content-between align-items-center">
            <div class="flex-grow-1">
              <p class="box__heading">Payment Method</p>
              <div class="d-flex flex-grow-1 align-items-center">
                <img width="40px" class="mr-2" :src="require(`@/assets/images/${(getCardIcon(paymentInfo.type.toLowerCase()))}.svg`)"/>
                <p class="box__text mb-0"> **** **** **** {{paymentInfo.last4}}</p>
              </div>
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body v-if="session" class="cp__order__info__box">
          <b-card-body class="d-flex justify-content-between align-items-center">
            <div class="flex-grow-1">
              <p class="box__heading">Shipping Address</p>
              <p class="box__text box__text__bold">{{customer.ship_first_name}} {{customer.ship_last_name}}</p>
              <p class="box__text">{{customer.ship_address1}}</p>
              <p v-if="customer.ship_address2" class="box__text">{{customer.ship_address2}}</p>
              <p class="box__text">
                {{customer.ship_city}} {{customer.ship_state}} {{customer.ship_zip}}</p>
              <p class="box__text mb-0" v-if="customer.ship_country === 'US'">USA</p>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import {getExpDate, getOrderDetail, removeOrderDetail, sortItems} from '@/utils'
import {InputType, PaymentSource, PaymentSourceStrings} from '@/constants'
import axios from 'axios'
import OrderTile from '@/components/Order/OrderTile'

export default {
  name: 'OrderDetail',
  components: {OrderTile},
  props: {
    input: Object,
    sideMenus: Array
  },
  data: function() {
    return {
      order: null,
      submitInput: null,
      paymentInfo: null
    }
  },
  computed: {
    ...mapState(['session']),
    customer: function() {
      return this.session && this.session.customer
    },
    validInputs: function() {
      return (this.session && this.session.valid_inputs) || []
    }
  },
  methods: {
    selectInput: function(data) {
      this.$emit('submit', data)
    },
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    backToOrderList: function() {
      let input = this.sideMenus.find((menu) => menu.type === InputType.CustomerPortalOrders)
      if (input && this.submitInput) {
        this.submitInput(input)
        removeOrderDetail()
      }
    },
    setSubmitInput: function() {
      let parent = this.$parent
      while (parent) {
        if (!parent['submitInput']) {
          parent = parent.$parent
        } else {
          this.submitInput = parent['submitInput']
          parent = null
        }
      }
    }
  },
  created() {
    const order = getOrderDetail()
    let requests = []
    if (this.session && this.session.customer && this.session.customer.default_payment_source) {
      requests.push(axios.get(`/payment_sources/${this.session.customer.default_payment_source}/`))
    }
    if (order) {
      requests = requests.concat(axios.get(`/order_items/?order=${order}`))
    }

    if (requests.length) {
      this.$store.commit('busy')
      Promise.all(requests).then(response => {
        const firstResponse = response[0]
        if (firstResponse.config && firstResponse.config.url.indexOf('order_items') === -1) {
          const paymentSource = firstResponse.data
          this.paymentInfo = {
            id: paymentSource.id,
            isDefault: paymentSource.is_default,
            canUpdate: paymentSource.can_update && (paymentSource.payment_source === PaymentSource.CreditCard),
            isCard: paymentSource.payment_source === PaymentSource.CreditCard,
            sourceType: paymentSource.payment_source,
            source: PaymentSourceStrings[paymentSource.payment_source],
            type: paymentSource.cc_type,
            last4: paymentSource.cc_last4,
            expDate: getExpDate(paymentSource.cc_exp_date),
            status: paymentSource.latest_status
          }
          response.splice(0, 1)
        }
        if (response.length) {
          const result = response[0]
          let items = result.data.results
          let order = {}

          sortItems(items)

          for (let i = 0; i < items.length; i++) {
            if (i === 0) {
              order = {
                id: items[i].order.id,
                order_id: items[i].order.order_id,
                created: items[i].order.created,
                subtotal: items[i].order.subtotal,
                shipping_price: items[i].order.shipping_price,
                hidden_fees: items[i].order.hidden_fees,
                tax: items[i].order.tax,
                charged: items[i].order.amount_charged,
                paid: items[i].order.amount_paid,
                discount: items[i].order.discount,
                total: items[i].order.total_discounted_price,
                total_remaining_balance: items[i].order.total_remaining_balance,
                amount_due: items[i].order.amount_due,
                pending_refund: items[i].order.pending_refund_amount,
                refund: items[i].order.settled_refund_amount,
                chargeback: items[i].order.chargeback_amount,
                forward_balance: items[i].order.forward_balance,
                past_balance: items[i].order.past_balance,
                status: items[i].order.status,
                payment_status: items[i].order.payment_status,
                tip: items[i].order.tip,
                currency: items[i].order.currency,
                store_credit: items[i].order.store_credit,
                store_debit: items[i].order.store_debit,
                items: []
              }
            }
            order['items'].push(items[i])
          }
          this.order = order
          this.$store.commit('hideLoader')

          if (!items.length) {
            this.canContinue = true
          }
          this.processing = false
        }
        this.$store.commit('ready')
      }, error => {
        this.$store.commit('critical_error', error)
        this.$store.commit('ready')
      })
    } else {
      this.$store.commit('ready')
    }
    this.setSubmitInput()
  }
}
</script>

<style scoped>

</style>
